import React, { createContext, useContext, useState, useEffect } from 'react';

const YouTubeContext = createContext();

const owners = [
  { youtubeChannelId: 'UCGPH1e_50rim2UzE423havg' },
  { youtubeChannelId: 'UCVoAZNkP_3Vo61jUERpvzCQ' }
];

const PLAYLIST_ID = 'PLhA8i-7lf8Fxwn3Hpz5m2GObkOAyZSjjq';

export function YouTubeProvider({ children }) {
  const [youtubeData, setYoutubeData] = useState({});
  const [loading, setLoading] = useState(true);
  const [hasFetched, setHasFetched] = useState(false);

  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [playlistLoading, setPlaylistLoading] = useState(true);
  const [hasPlaylistFetched, setHasPlaylistFetched] = useState(false);

  // Fetch channel data
  useEffect(() => {
    if (hasFetched) return;

    const fetchYoutubeData = async () => {
      try {
        const channelIds = owners.map(o => o.youtubeChannelId).join(',');
        const response = await fetch(`/api/youtube?channelIds=${channelIds}`);

        if (!response.ok) {
          throw new Error('Failed to fetch YouTube data');
        }

        const data = await response.json();

        const dataMap = {};
        data.forEach(channel => {
          dataMap[channel.id] = channel;
        });

        setYoutubeData(dataMap);
      } catch (err) {
        console.error('Error fetching YouTube data:', err);
      } finally {
        setLoading(false);
        setHasFetched(true);
      }
    };

    fetchYoutubeData();
  }, [hasFetched]);

  // Fetch playlist videos (runs in parallel with channel data)
  useEffect(() => {
    if (hasPlaylistFetched) return;

    const fetchPlaylistVideos = async () => {
      try {
        const response = await fetch(
          `/api/youtube?type=playlist&playlistId=${PLAYLIST_ID}&maxResults=4`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch playlist videos');
        }

        const data = await response.json();
        setPlaylistVideos(data);
      } catch (err) {
        console.error('Error fetching playlist videos:', err);
      } finally {
        setPlaylistLoading(false);
        setHasPlaylistFetched(true);
      }
    };

    fetchPlaylistVideos();
  }, [hasPlaylistFetched]);

  return (
    <YouTubeContext.Provider value={{ youtubeData, loading, playlistVideos, playlistLoading }}>
      {children}
    </YouTubeContext.Provider>
  );
}

export function useYouTubeData() {
  const context = useContext(YouTubeContext);
  if (!context) {
    throw new Error('useYouTubeData must be used within a YouTubeProvider');
  }
  return context;
}
